export default __webpack_public_path__ + "static/media/ebrima.d6bca5f6.ttf";